import dayjs, { type Dayjs } from 'dayjs';
import type { CalendarItem } from '@/types/contentPlanner';

/**
 * The planner table's month tabs scope SCHEDULED content to the selected month.
 *
 * Items that are not yet on the calendar (no real scheduled date — drafts,
 * pending, in-progress, or finished-but-unscheduled) are a work backlog and must
 * stay visible regardless of the month being viewed. Otherwise a freshly-created
 * item silently disappears whenever the table is navigated to another month
 * (the backend gives every row a `scheduled_date` that falls back to created_at,
 * so it can't be used to detect scheduling — use `is_scheduled`).
 */
export function isVisibleInSelectedMonth(
  item: CalendarItem,
  selectedMonth: Dayjs,
): boolean {
  // Backlog (unscheduled) items always show — they aren't calendar-positioned.
  if (!item.is_scheduled) return true;

  const raw = item.scheduled_date || item.created_at;
  if (!raw) return false;
  const d = dayjs(raw);
  return d.year() === selectedMonth.year() && d.month() === selectedMonth.month();
}
